import React from 'react';
import { Stack, TextField } from '@mui/material';
import { CptFormErrors } from '../hooks';

interface CodeApcFieldsProps {
    code: string;
    apcCode: string;
    errors: CptFormErrors;
    onChange: (field: 'code' | 'apcCode', value: string) => void;
}

export const CodeApcFields: React.FC<CodeApcFieldsProps> = ({
    code,
    apcCode,
    errors,
    onChange
}) => {
    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
                label="CPT Code"
                value={code}
                onChange={(e) => onChange('code', e.target.value)}
                error={!!errors.code}
                helperText={errors.code}
                size="small"
                sx={{ flex: 1 }}
                inputProps={{ maxLength: 20 }}
            />
            <TextField
                label="APC Code"
                value={apcCode}
                onChange={(e) => onChange('apcCode', e.target.value)}
                error={!!errors.apcCode}
                helperText={errors.apcCode || 'Optional'}
                size="small"
                sx={{ flex: 1 }}
                inputProps={{ maxLength: 20 }}
                placeholder="Optional"
            />
        </Stack>
    );
};
